import * as React from 'react';
import { Link } from 'react-router';
import styled from 'styled-components';
import { rem } from 'polished';
import { FlexCol, TextP } from '../../..';
import { formatPrice } from '../../../utilities';
import { __ } from 'react-i18n';
import { StockInfo } from '../Product/StockInfo';

interface Props {
  picture: string;
  url: string;
  name: string;
  description: string;
  price: number;
  currency: string;
  availid?: any;
  availability?: any;
  onStockCount?: number;
  isNew?: boolean;
  condition?: any;
  conditionTextMapping?: any;
  isWaiting?:boolean;
}

function RelatedProduct(props: Props) {
  const {
    picture,
    url,
    name,
    description,
    price,
    currency,
    availid,
    availability,
    isNew,
    condition,
    conditionTextMapping,
    isWaiting
  } = props;

  return (
    <>
      <ProductWrapper to={url}>
        <Image
          alt={`${__('Obrázok produktu')} ${name}`}
          src={picture ? `${picture}` : `/images/icons/placeholder.svg`}
        />
        <InfoWrapper>
          <Name>{`${name}`}</Name>
          <Description>
            <div
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: description }}
            />
          </Description>
          <Price>{formatPrice(price, currency, 2)}</Price>
          <StockInfoWrapper>
            <StockInfo
              avail_id={availid}
              availability={availability}
              isNew={!!isNew}
              condition={condition}
              conditionTextMapping={conditionTextMapping}
              isWaiting={isWaiting}
            />
          </StockInfoWrapper>
        </InfoWrapper>
      </ProductWrapper>
    </>
  );
}

const ProductWrapper = styled(Link)`
  width: 100%;
  padding: ${rem(24)};
  text-decoration: none;
  display: flex;
  flex-direction: row;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.08);
  border: ${rem(1)} solid #cccccc;
  border-radius: ${rem(4)};
`;

const Image = styled.img`
  /* height: ${rem(104)}; */
  margin-right: ${rem(24)};
  width: 48%;
  max-width: ${rem(136)};
  object-fit: contain;
`;

const Name = styled(TextP)`
  font-weight: 500;
  margin-bottom: ${rem(8)};
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
`;

const Description = styled.div`
  font-size: ${rem(14)};
  color: ${({ theme }) => theme.blogColors.gray};
  margin-bottom: ${rem(16)};
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;

  p {
    margin-block-start: 0;
    margin-block-end: 0;
  }
`;

const Price = styled(TextP)`
  color: ${({ theme }) => theme.colors.textPrimary} !important;
  font-size: ${rem(24)} !important;
  font-weight: 500 !important;
`;

const InfoWrapper = styled(FlexCol)`
  width: 53%;
`;

const StockInfoWrapper = styled.div`
  margin-top: 15px;
`;

export { RelatedProduct as DsiRelatedProduct };
